import { Stack } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Chip } from '@/shared/components/ui/chip/chip';
import { GroupedItemContextMenuRenderer } from '@/shared/features/groups/components/grouped-item-context-menu/grouped-item-context-menu.renderer';

export const GroupTenantContextMenuRenderer: React.FC<ICellRendererParams> = (
  params,
) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      gap="1rem"
      alignItems="center"
      justifyContent="flex-end"
      height="100%"
    >
      <Chip
        status={params.data.isActive ? 'green' : 'grey'}
        label={params.data.isActive ? t('common:active') : t('common:inactive')}
      />
      <GroupedItemContextMenuRenderer {...params} />
    </Stack>
  );
};
